jQuery(function($){
    $('#btn_circular .btn').on('click',function(){
        $('#circular').removeClass('d-none');
        $('#climate').addClass('d-none');
        $('#system').addClass('d-none');
        $(this).parents('.col-lg-4').removeClass('opacity_50');
        $(this).parents('.col-lg-4').siblings().addClass('opacity_50');
    })
    $('#btn_climate .btn').on('click',function(){
        $('#climate').removeClass('d-none');
        $('#circular').addClass('d-none');
        $('#system').addClass('d-none');
        $(this).parents('.col-lg-4').removeClass('opacity_50');
        $(this).parents('.col-lg-4').siblings().addClass('opacity_50');
    })
    $('#btn_system .btn').on('click',function(){
        $('#system').removeClass('d-none');
        $('#climate').addClass('d-none');
        $('#circular').addClass('d-none');
        $(this).parents('.col-lg-4').removeClass('opacity_50');
        $(this).parents('.col-lg-4').siblings().addClass('opacity_50');
    })
})